'use client'

import { useEffect, useMemo, useState, useSyncExternalStore } from 'react'
import { usePathname } from 'next/navigation'
import SimpleAuthModal from '@/components/auth/SimpleAuthModal'
import { useAuth } from '@/lib/context/AuthContext'
import { clearPendingSignIn, loadPendingSignIn, type PendingSignIn } from '@/lib/auth/pendingSignIn'

// Read once per page load: only a sign-in pending when the tab (re)loaded is
// resumed. One started on this page afterwards already has its own modal open.
let atLoad: PendingSignIn | null | undefined
const readAtLoad = () => {
  if (atLoad === undefined) atLoad = loadPendingSignIn(window.location.pathname + window.location.search)
  return atLoad
}
const noSubscription = () => () => {}

/**
 * Reopens the code screen after the tab reloaded mid sign-in (the phone
 * discarded it while the person was in their mail app). See pendingSignIn.ts.
 */
export default function ResumePendingSignIn() {
  const { user } = useAuth()
  const pathname = usePathname()
  const pending = useSyncExternalStore(noSubscription, readAtLoad, () => null)
  const [closed, setClosed] = useState(false)

  // Signed in meanwhile (the link from the email, another tab): nothing to resume.
  useEffect(() => {
    if (user) clearPendingSignIn()
  }, [user])

  const show = useMemo(() => !!pending && !user && !closed && pending.path.split('?')[0] === pathname, [pending, user, closed, pathname])
  if (!show || !pending) return null

  return (
    <SimpleAuthModal
      isOpen
      resume={pending}
      returnTo={pending.returnTo}
      onClose={() => setClosed(true)}
    />
  )
}
